import styled from "styled-components";
type Props = {
  data: number;
  color?: string;
  className?: string;
};
const RoundedBadge = ({ data, color, className }: Props) => {
  return (
    <StyledRoundedBadge
      className={`badge rounded rounded-ill ${
        color ? `bg-${color}` : "bg-primary"
      } ${className || ""}`}
    >
      {data}
    </StyledRoundedBadge>
  );
};
const StyledRoundedBadge = styled.span`
  /* padding-top: 5px; */
  width: unset !important;
  height: unset !important;
  padding: 0 10px !important;
  font-size: 0.7rem !important;
  border-radius: 50%;
  background-color: var(--primary2);
  font-family: Arial;
  color: #fff;
  font-size: 0.75rem;
  font-weight: 500;
  text-align: center;
  line-height: 1.125rem;
`;
export default RoundedBadge;
